import { connect }    from 'react-redux';
import AccountHistory from './activity-history.jsx';

import {
    fetchActivityHistoryData,
    sortByColumn,
    navigateToPage,
    fetchDates
} from './activity-history-dux';

export default connect(
    // mapStateToProps
    state=> ( {
        ...state.activityHistoryData,
        accountNumber: state.activityHistoryData.accountNumber || '',
        busyFetchingAccountHistory: state.activityHistoryData.busyFetchingAccountHistory,
        actualData: state.activityHistoryData.actualData,
        userName: state.userData.userName,
        locale: state.userData.locale && state.userData.locale.code || 'en-US'
    } ),
    // mapDispatchToProps
    {
        fetchData: fetchActivityHistoryData,
        handleSort: sortByColumn,
        handlePageNavigation: navigateToPage,
        fetchDates: fetchDates
    }
)( AccountHistory );
